import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, comite_executivo } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './ComiteExecutivo.scss';

class ComiteExecutivo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.comite_executivo = comite_executivo.pessoas;
    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Comitê executivo - Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="comite-executivo-home page-gradient page-gradient--green bg-gray" ref="comite-executivo-home">
          <section className="comite-executivo-home-area governanca-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title">Comitê executivo</h1>
                      <p className="page-header__description gri_text">
                        Grupo formado pelas principais lideranças da equipe <br />
                        interna, que ajuda na tomada de decisões executivas. <br />
                        <strong>São dez membros, cinco homens e cinco mulheres.</strong>
                        <span className="gri_label">
                          GRI <b>405-1</b>
                        </span>
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7">
                  <img src={this.images.comite_executivo.ilustra1} className="first-image" />
                  <img src={this.images.comite_executivo.ilustra1_1} className="second-image" />
                  <svg viewBox="0 0 340 333" className="third-image">
                    <polyline
                      className="path"
                      fill="transparent"
                      stroke="#0091D7"
                      stroke-width="4"
                      points="23,150 84,69 127,110 156,64 192,77 238,27 "
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <h2 className="center-title">Conheça os integrantes do comitê:</h2>

                      <CardSliderFotos
                        items={this.comite_executivo}
                        url={this.images.comite_executivo.path_url}
                        color={'green'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="comite-executivo-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-9 col--text">
                            <h4>Confira o perfil da nossa equipe interna</h4>
                            <DelayLink
                              to="/pessoas"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-3 col--image">
                            <img
                              src={this.images.comite_executivo.pessoa1}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { ComiteExecutivo };
